module.exports = __webpack_public_path__ + "static/camera7-4240674970202dd7c859b2a4ed2b3f98.jpg";